import { render } from "./Surveys.vue?vue&type=template&id=2265f81e&scoped=true"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"

import "./Surveys.vue?vue&type=style&index=0&id=2265f81e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2265f81e"]])

export default __exports__